import React from "react";

export default function Modal({ heading, paragraph, close }) {
  return (
    <div className="modal modal-open">
      <div className="modal-box relative max-w-lg rounded-lg bg-white p-4 shadow-xl">
        {/* Top-right close button */}
        <button
          className="hover-text-white btn btn-circle btn-xs absolute right-1 top-1 border border-red-500 bg-white text-red-500  hover:bg-red-500 hover:text-white"
          onClick={close}
        >
          ✕
        </button>

        {/* Gradient Header */}
        <div className="mb-4 rounded-lg bg-gradient-to-r from-orange-400 to-yellow-500 p-2 text-white">
          <h3 className="text-center text-2xl font-extrabold">{heading}</h3>
        </div>

        {/* Content Area */}
        <div className={`text-gray-700 ${!paragraph ? "text-center" : ""}`}>
          <p className="mb-4">{paragraph || "Empty"}</p>
        </div>
      </div>
    </div>
  );
}
